/* Get Up & Design - al elegir un acabado, pone delante la imagen de ese acabado.
   Empareja el valor de la opcion con el alt de las muestras ("Muestra del acabado <color> ..."). */
(function () {
  function palabraColor(valor) {
    var v = (valor || '').toLowerCase();
    var claves = ['silver', 'negro', 'cromo', 'blanco', 'inox', 'oro rosa', 'oro', 'bronce', 'blanco mate'];
    for (var i = 0; i < claves.length; i++) { if (v.indexOf(claves[i]) >= 0) return claves[i]; }
    return null;
  }
  function aplicar() {
    var galeria = document.querySelector('media-gallery [id^="Slider-Gallery"]') || document.querySelector('media-gallery ul');
    if (!galeria) return;
    var elegidos = [].slice.call(document.querySelectorAll('variant-selects input[type="radio"]:checked')).map(function (i) { return i.value; });
    if (!elegidos.length) return;
    var color = null;
    for (var i = elegidos.length - 1; i >= 0 && !color; i--) color = palabraColor(elegidos[i]);
    if (!color) return;
    var lis = [].slice.call(galeria.querySelectorAll('li'));
    for (var j = 0; j < lis.length; j++) {
      var img = lis[j].querySelector('img');
      var alt = (img && img.alt ? img.alt : '').toLowerCase();
      if (alt.indexOf('acabado ' + color) >= 0 || alt.indexOf(color + ' de la perfiler') >= 0) {
        if (galeria.firstElementChild !== lis[j]) {
          galeria.insertBefore(lis[j], galeria.firstElementChild);
          var mediaGallery = document.querySelector('media-gallery');
          if (mediaGallery && mediaGallery.setActiveMedia) {
            var id = lis[j].getAttribute('data-media-id') || (lis[j].id || '').replace(/^Slide-/, '');
            if (id) mediaGallery.setActiveMedia(id, true);
          }
          window.scrollTo({ top: Math.max(0, galeria.getBoundingClientRect().top + window.scrollY - 90), behavior: 'smooth' });
        }
        return;
      }
    }
  }
  function init() {
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      aplicar();
    }, true);
    if (document.readyState !== 'loading') setTimeout(aplicar, 300);
    else document.addEventListener('DOMContentLoaded', function () { setTimeout(aplicar, 300); });
  }
  init();
})();
